import { Input } from "../../../components/Input/input";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { StyledButton } from "../../../components/Button/button";
import { theme } from "../../../helpers/theme";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInputProps,
  Select,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { PriceList } from "../../../services/pricelists/pricelist-get-by-id/types";
import { pricelistupdate } from "../../../services/pricelists/pricelist-edit";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useEffect, useState } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { pl } from "date-fns/locale";
import { Dayjs } from "dayjs";

export const PricelistForm = (pricelistData: PriceList[]) => {
  const { id } = useParams();
  const { state } = useLocation();
  const { id_magazyn, pricelist } = state;
  const pData = pricelistData[0];
  const [fromDate, setFromDate] = useState<Dayjs | Date | null | undefined>(
    pData.wazny_od
  );
  const [toDate, setToDate] = useState<Dayjs | Date | null | undefined>(
    pData.wazny_do ? pData.wazny_do : null
  );
  const [dateError, setDateError] = useState<boolean>(false);
  const [dateFromInvalid, setDateFromInvalid] = useState<string | null>(null);
  const [dateToInvalid, setDateToInvalid] = useState<string | null>(null);
  const [PricelistPosition, setPricelistPosition] = useState<number | null>(
    null
  );

  useEffect(() => {
    const FilteredPricelists = pricelist.filter(
      (item: PriceList) =>
        item.rodzaj_oferty === pData.rodzaj_oferty &&
        item.usluga_magazynu === pData.usluga_magazynu
    );
    const SortedPricelists = FilteredPricelists.sort((a: any, b: any) => {
      return new Date(b.wazny_od).getTime() - new Date(a.wazny_od).getTime();
    });
    const sortedListLenght = SortedPricelists.length;
    if (sortedListLenght === 1) {
      setPricelistPosition(3);
    } else {
      SortedPricelists.filter((item: any, index: number) => {
        if (item.id_cennik === pData.cennik_id) {
          if (index === 0) {
            setPricelistPosition(2);
          } else if (index === sortedListLenght - 1) {
            setPricelistPosition(0);
          } else {
            setPricelistPosition(1);
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    if (fromDate === null || toDate === null) {
      setDateError(true);
    } else if (fromDate != null && toDate != null && fromDate > toDate) {
      setDateError(true);
    } else {
      setDateError(false);
    }
  }, [fromDate, toDate]);

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const EditPricelistMutation = useMutation(pricelistupdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });

  const validationSchema = yup.object({
    jednostka_rozliczenia: yup
      .number()
      .required("Jednostka rozliczenia jest wymagana"),
    stawka_netto: yup
      .string()
      .matches(/^[0-9]+(\.[0-9]{1,2})?$/, "Błędny format!")
      .min(0, "Stawka netto nie może być ujemna")
      .max(9, "Maksymalna długość to 9 znaków")
      .typeError("Błędny format!")
      .required("Stawka netto jest wymagana"),
    nazwa: yup
      .string()
      .max(100, "Maksymalna długość to 100 znaków")
      .required("Nazwa jest wymagana"),
    nazwa_na_fakture: yup
      .string()
      .max(100, "Maksymalna długość to 100 znaków")
      .required("Nazwa na fakturze jest wymagana"),
    usluga_magazynu: yup.number().required("Usługa magazynu jest wymagana"),
    rodzaj_oferty: yup.number().required("Rodzaj oferty jest wymagany"),
  });
  const formik = useFormik({
    initialValues: {
      jednostka_rozliczenia: pData.jednostka_rozliczenia,
      stawka_netto: pData.stawka_netto ? pData.stawka_netto.toString() : "",
      nazwa: pData.nazwa,
      nazwa_na_fakture: pData.nazwa_na_fakture,
      usluga_magazynu: pData.usluga_magazynu,
      rodzaj_oferty: pData.rodzaj_oferty,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        magazyn_id: id_magazyn,
        cennik_id: id,
        jednostka_rozliczenia: values.jednostka_rozliczenia,
        stawka_netto: parseFloat(values.stawka_netto.replace(",", ".")),
        wazny_od: fromDate,
        wazny_do: toDate,
        nazwa: values.nazwa,
        nazwa_na_fakture: values.nazwa_na_fakture,
        rodzaj_oferty: values.rodzaj_oferty,
        usluga_magazynu: values.usluga_magazynu,
      };
      EditPricelistMutation.mutate(body);
    },
  });

  // if (EditClient.isLoading) {
  //   return <LoadingBackDrop loading={true} />;
  // }
  return (
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <FormControl fullWidth>
          <InputLabel id="jednostka_rozliczenia-label">
            Jednostka rozliczenia
          </InputLabel>
          <Select
            placeholder="Jednostka rozliczenia"
            labelId="jednostka_rozliczenia-label"
            label="Jednostka rozliczenia"
            id="jednostka_rozliczenia"
            name="jednostka_rozliczenia"
            value={formik.values.jednostka_rozliczenia}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Paletodoba</MenuItem>
            <MenuItem value={1}>Paleta</MenuItem>
            <MenuItem value={2}>Paleta mix</MenuItem>
            <MenuItem value={3}>Etykieta lub karton</MenuItem>
            <MenuItem value={4}>Sztuka lub karton</MenuItem>
            <MenuItem value={5}>m²</MenuItem>
            <MenuItem value={6}>m³</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="usluga_magazynu-label">Usługa magazynu</InputLabel>
          <Select
            placeholder="Usługa magazynu"
            labelId="usluga_magazynu-label"
            label="Usługa magazynu"
            id="usluga_magazynu"
            name="usluga_magazynu"
            value={formik.values.usluga_magazynu}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Składowanie</MenuItem>
            <MenuItem value={1}>Crossdocking</MenuItem>
            <MenuItem value={2}>Fullfilment</MenuItem>
            <MenuItem value={3}>Etykietowanie</MenuItem>
            <MenuItem value={4}>Pakowanie</MenuItem>
            <MenuItem value={5}>Sortowanie</MenuItem>
            <MenuItem value={6}>E_commerce</MenuItem>
            <MenuItem value={7}>Wysyłka</MenuItem>
            <MenuItem value={8}>Inne</MenuItem>
            <MenuItem value={9}>Przyjecie_towaru</MenuItem>
            <MenuItem value={10}>Wydanie_towaru</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="rodzaj_oferty-label">Rodzaj oferty</InputLabel>
          <Select
            placeholder="Rodzaj oferty"
            labelId="rodzaj_oferty-label"
            label="Rodzaj oferty"
            id="rodzaj_oferty"
            name="rodzaj_oferty"
            value={formik.values.rodzaj_oferty}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Magazyn dedykowany</MenuItem>
            <MenuItem value={1}>Multimagazyn</MenuItem>
          </Select>
        </FormControl>
        <Input
          label="Stawka netto"
          id="stawka_netto"
          name="stawka_netto"
          value={formik.values.stawka_netto}
          onChange={formik.handleChange}
          error={
            formik.touched.stawka_netto && Boolean(formik.errors.stawka_netto)
          }
          helperText={formik.touched.stawka_netto && formik.errors.stawka_netto}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
          <DatePickersWrapper>
            <DesktopDatePicker
              views={["day"]}
              label="Ważny od"
              // disablePast
              value={fromDate}
              disabled={
                PricelistPosition === 0 || PricelistPosition === 3
                  ? false
                  : true
              }
              InputProps={
                { disableUnderline: true } as Partial<OutlinedInputProps>
              }
              onError={(error) => setDateFromInvalid(error)}
              onChange={(newValue) => {
                setFromDate(newValue);
              }}
              renderInput={(params) => (
                <InputWrapper style={{ justifyContent: "flex-start" }}>
                  <Input
                    {...params}
                    helperText={null}
                    variant="filled"
                    sx={{
                      width: "100%",
                      // minWidth: "300px",
                    }}
                  />
                </InputWrapper>
              )}
            />

            <DesktopDatePicker
              views={["day"]}
              label="Ważny do"
              // disablePast
              minDate={fromDate}
              value={toDate}
              disabled={
                PricelistPosition === 2 || PricelistPosition === 3
                  ? false
                  : true
              }
              InputProps={
                { disableUnderline: true } as Partial<OutlinedInputProps>
              }
              onError={(error) => setDateToInvalid(error)}
              onChange={(newValue) => {
                setToDate(newValue);
              }}
              renderInput={(params) => (
                <InputWrapper style={{ justifyContent: "flex-end" }}>
                  <Input
                    {...params}
                    helperText={null}
                    variant="filled"
                    sx={{
                      //  marginRight: "13px",
                      width: "100%",
                      // minWidth: "300px",
                    }}
                  />
                </InputWrapper>
              )}
            />
          </DatePickersWrapper>
        </LocalizationProvider>
        <Input
          label="Nazwa"
          id="nazwa"
          name="nazwa"
          value={formik.values.nazwa}
          onChange={formik.handleChange}
          error={formik.touched.nazwa && Boolean(formik.errors.nazwa)}
          helperText={formik.touched.nazwa && formik.errors.nazwa}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Nazwa na fakturze"
          id="nazwa_na_fakture"
          name="nazwa_na_fakture"
          value={formik.values.nazwa_na_fakture}
          onChange={formik.handleChange}
          error={
            formik.touched.nazwa_na_fakture &&
            Boolean(formik.errors.nazwa_na_fakture)
          }
          helperText={
            formik.touched.nazwa_na_fakture && formik.errors.nazwa_na_fakture
          }
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <StyledButton
          disabled={
            !formik.isValid ||
            EditPricelistMutation.isLoading ||
            dateError ||
            (dateFromInvalid === null ? false : true) ||
            (dateToInvalid === null ? false : true)
          }
          type="submit"
          variant="contained"
        >
          Zapisz
        </StyledButton>
      </FormWrapper>
    </BasicFormWrapper>
  );
};

export default PricelistForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;

const InputWrapper = styled.div`
  width: 49%;
  display: flex;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;
